export const ChevronUp = () => {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none'>
      <path
        d='M15 13L10 8L5 13'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
